export default __webpack_public_path__ + "static/media/emoji5.9725657f.svg";